<template>
  <div id="complaintSuggestion">
    <van-sticky>
      <van-nav-bar left-text="返回" title="投诉与建议" left-arrow @click-left="onClickLeft"></van-nav-bar>
    </van-sticky>
    <div class="c-container">
      <div class="con-box">
        <div class="box-title">联系方式</div>

        <div class="box-item" v-if="email">
          <van-icon name="envelop-o" color="#4d90e0" class="item-icon" />
          <div class="item-msg">
            <div class="msg-title">电子邮箱</div>
            <div class="msg-content">{{ email }}</div>
          </div>
        </div>
        <div class="box-item" v-if="phone">
          <van-icon name="phone" color="#4d90e0" class="item-icon" />
          <div class="item-msg">
            <div class="msg-title">服务热线</div>
            <div class="msg-content" @click="handClickPhone">{{ phone }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  name: 'complaintSuggestion',
  data() {
    return {
      email: '',
      phone: '0991-2819852'
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
        path: '/'
      });
    },
    handClickPhone() {
      this.copyText(this.phone);
      try {
        wx.makePhoneCall({
          phoneNumber: this.phone
        });
      } catch (error) {}
    },
    copyText(text) {
      try {
        navigator.clipboard.writeText(text).then(() => {
          Toast.success('复制剪切板');
        });
      } catch (error) {
        try {
          // 创建一个临时文本区域
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed'; // 确保它不在视口中
          document.body.appendChild(textarea);

          // 选中并复制
          textarea.select();
          document.execCommand('copy');

          // 清理临时元素
          document.body.removeChild(textarea);
          Toast.success('复制剪切板');
        } catch (e) {
          Toast.fail('复制失败，请手动复制');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#complaintSuggestion {
  background: #f0f2f1;
  height: 100%;
}
.c-container {
  padding: 0.24rem;
  .con-box {
    background-color: #fff;
    border-radius: px2rem(30);
    box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
    .box-title {
      font-weight: bold;
      font-size: px2rem(50);
      padding: 0.45rem 0.38rem;
      columns: #000;
      border-bottom: 1px solid #ddd;
    }
    .box-item {
      padding: px2rem(30) px2rem(40);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .item-icon {
        margin-right: px2rem(40);
        font-weight: bold;
      }
      .item-msg {
        display: flex;
        flex-direction: column;
        padding: px2rem(10) 0px;
        .msg-title {
          font-size: px2rem(45);
          color: #848b94;
          margin-bottom: px2rem(10);
        }
        .msg-content {
          font-size: px2rem(45);
          color: #4d90e0;
        }
      }
    }
  }
}
</style>
